import type { Metadata } from '@lumapps/metadata/types';

import type { MetadataMap } from '../types';

/**
 * Finds the root parent of a metadata by traversing up the parent chain
 */
export const findRootMetadata = (metadata: Metadata, metadataMap: MetadataMap): Metadata => {
    let current = metadata;

    // Traverse up the parent chain until we find the root
    while (current.parent) {
        const parent = metadataMap.get(current.parent);
        if (!parent) {
            break; // Parent can't be found in the Map
        }
        current = parent;
    }

    return current;
};
